var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_258_618",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_258_618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9375 54.875C26.8542 54.875 23.9479 54.2917 21.2188 53.125C18.4896 51.9583 16.1146 50.3542 14.0938 48.3125C12.0729 46.2708 10.4688 43.8958 9.28125 41.1875C8.09375 38.4792 7.5 35.5625 7.5 32.4375C7.5 29.3542 8.09375 26.4479 9.28125 23.7188C10.4688 20.9896 12.0729 18.6042 14.0938 16.5625C16.1146 14.5208 18.4896 12.9167 21.2188 11.75C23.9479 10.5833 26.8542 10 29.9375 10C33.0208 10 35.9271 10.5833 38.6562 11.75C41.3854 12.9167 43.7708 14.5208 45.8125 16.5625C47.8542 18.6042 49.4583 20.9896 50.625 23.7188C51.7917 26.4479 52.375 29.3542 52.375 32.4375C52.375 35.5625 51.7917 38.4792 50.625 41.1875C49.4583 43.8958 47.8542 46.2708 45.8125 48.3125C43.7708 50.3542 41.3854 51.9583 38.6562 53.125C35.9271 54.2917 33.0208 54.875 29.9375 54.875ZM37.5 42.625L40.125 40L32 31.875V20H28.25V33.375L37.5 42.625ZM13.375 5.8125L16 8.4375L5.75 18.3125L3.125 15.6875L13.375 5.8125ZM46.5 5.8125L56.75 15.6875L54.125 18.3125L43.875 8.4375L46.5 5.8125Z",
    fill: "#D42216"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.edeb8fbcb4e1096f4bd4f1770ecd7dc6.svg";
export { ForwardRef as ReactComponent };